import React from "react";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { ElementLabel } from "./components/BaseElements";
import { InputWithMargin } from "../../editor/Input";
const Container = styled.div.withConfig({
  displayName: "FadeCameraActionDetails__Container",
  componentId: "sc-1h8jz7u-0"
})(["width:100%;"]);
const OptionHeader = styled.div.withConfig({
  displayName: "FadeCameraActionDetails__OptionHeader",
  componentId: "sc-1h8jz7u-1"
})(["display:flex;flex-direction:row;"]);
const InputOption = styled(ElementLabel).withConfig({
  displayName: "FadeCameraActionDetails__InputOption",
  componentId: "sc-1h8jz7u-2"
})(["display:flex;flex-direction:row;margin:4px;cursor:pointer;"]);
const Row = styled.div.withConfig({
  displayName: "FadeCameraActionDetails__Row",
  componentId: "sc-1h8jz7u-3"
})(["display:flex;flex-direction:row;"]);
const HeaderText = styled.div.withConfig({
  displayName: "FadeCameraActionDetails__HeaderText",
  componentId: "sc-1h8jz7u-4"
})(["margin-top:2px;margin-left:4px;"]);
export const FadeCameraActionDetails = observer(({
  action
}) => {
  const {
    t
  } = useTranslation();

  function onFadeInClicked() {
    action.setFadeIn(true);
  }

  function onFadeOutClicked() {
    action.setFadeIn(false);
  }

  function toggleDuration() {
    action.setWithDuration(!action.withDuration);
  }

  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(OptionHeader, null, /*#__PURE__*/React.createElement(HeaderText, null, t("action_editor.node_fade_overlay_headline"))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(InputOption, {
    onClick: onFadeInClicked
  }, /*#__PURE__*/React.createElement(InputWithMargin, {
    type: "radio",
    checked: action.fadeIn,
    onChange: e => {}
  }), t("action_editor.node_fade_overlay_fade_in")), /*#__PURE__*/React.createElement(InputOption, {
    onClick: onFadeOutClicked
  }, /*#__PURE__*/React.createElement(InputWithMargin, {
    type: "radio",
    checked: !action.fadeIn,
    onChange: e => {}
  }), t("action_editor.node_fade_overlay_fade_out"))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(InputOption, null, /*#__PURE__*/React.createElement(InputWithMargin, {
    type: "checkbox",
    checked: action.withDuration,
    onChange: toggleDuration
  }), t("action_editor.node_fade_overlay_use_duration"))));
});